import React, {useRef, useState, useMemo} from 'react'
import JoditEditor from "jodit-react";
import { FormCustom } from '../../Components/Form/Form'
import { useEffect } from 'react';
import Controllers from '../../Api/Controllers';
import { useCallback } from 'react';
import Helpers from '../../Components/Helpers/Helpers';
import { SurfaceCard, PageHeader } from '../../Components/Ui'
import {toast} from 'react-toastify'
import ReactPlaceholder from 'react-placeholder/lib';
import { useHistory } from 'react-router-dom';

const btnPrimary = {
    borderRadius: 12,
    fontWeight: 700,
    minHeight: 42,
    width: '100%',
    padding: '0 18px',
    background: '#201030',
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8
}

const Organigrama = ({ readonly }) => {
    const [ organigrama, setOrganigrama ] = useState({})
    const [ready, setReady] = useState(false)

    const history = useHistory()

    const config = useMemo(() => {
        if (readonly) {
            return {
                minHeight: 450,
                preset: 'inline',
                readonly
            }
        } else {
            return {
                minHeight: 450,
                language: 'es',
                askBeforePasteHTML: false,
                askBeforePasteFromWord: false,
            }
        }
    }, [readonly])

    useEffect(() => {
        Controllers.text.get_organigrama().then(res => {
            setOrganigrama(res.data)
            setReady(true)
        })
    }, [])

    const editorOrganigrama = useRef(null)

    const contentHTMLOrganigrama = useMemo(() => {
        return <>
        <JoditEditor
            ref={editorOrganigrama}
            value={organigrama?.content_text ? organigrama.content_text : ''}
            config={config}
            tabIndex={1}
            onBlur={_ => {
                setOrganigrama({ ...organigrama, content_text: editorOrganigrama.current.value })
            }}
        /></>
    }, [editorOrganigrama, config, organigrama])

    const dataSubmit = useCallback(() => {
        return {
            p_organigrama: organigrama,
        }
    }, [organigrama])

    const [loadSubmit, setLoadSubmit] = useState(false)

    const handleSubmit = ({ data }) => {
        setLoadSubmit(true)
        Controllers.text.organigrama_update(data).then(res => {
            Helpers.toast.construct({ ...res, toast, message: 'Cambios guardados correctamente.' })
            history.push(Helpers.config.convertUrl({ url: '/organigrama' }))
        }).catch(req => Helpers.promise.catch({ req, toast }))
        .finally(() => {
            setLoadSubmit(false)
        })
    }

    return <>
        <PageHeader
            eyebrow="Super Papelera — Espacio de trabajo"
            title="Organigrama"
            subtitle="Actualiza el organigrama institucional."
        />
        <ReactPlaceholder ready={ready} showLoadingAnimation rows={15}>
            <FormCustom dataSubmit={dataSubmit()} onSubmit={handleSubmit} loadSubmit={loadSubmit} viewSubmit={false}>
                <div className={'mb-2 col-12 col-md-' + (readonly ? '12' : '9')}>
                    <SurfaceCard>
                        <h3 className="text-center" style={{ color: '#201030', fontWeight: 700 }}>Organigrama</h3>
                        {contentHTMLOrganigrama}
                    </SurfaceCard>
                </div>
                {readonly ? '' : <div className="col-12 col-md-3">
                    <SurfaceCard title="Actualizar">
                        <p style={{ color: '#6B7280', fontSize: '0.9rem' }}>
                            Da click en el botón para guardar los cambios realizados.
                        </p>
                        <button type="submit" style={btnPrimary}>
                            {loadSubmit
                                ? <i className="fa fa-circle-notch fa-spin" />
                                : <><i className="fa fa-plus" />Guardar Cambios</>}
                        </button>
                    </SurfaceCard>
                </div>}
            </FormCustom>
        </ReactPlaceholder>
    </>
}

Organigrama.defaultProps = {
    readonly: false
}

export default Organigrama
